let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ilcot")).then(() => parcelRequire('4YfiR'));